module.exports = __webpack_public_path__ + "img/no_zone_selected.20864f00.svg";